import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import api from './utils/index.js'
import jumuc from './utils/api.js'
import { Lazyload, Toast, Icon, Dialog } from 'vant';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./assets/iconfont/iconfont.css";
import "./assets/css/base.css";
import "./assets/css/wx.css";
import './utils/appback.js';
import checkMobile from './utils/checkMobile.js';
import VueTouch from 'vue-touch';
import BackTop from './components/BackTop';
import Router from 'vue-router'
import 'vant/lib/index.css';
Vue.use(Router)
VueTouch.config.swipe = {
    threshold: 200,
    direction: 'horizontal'
}
Vue.use(VueTouch, { name: 'v-touch' });

//Vue.use(axios)
Vue.component("BackTop", BackTop);
Vue.use(Lazyload)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Icon)
Vue.config.productionTip = false
Vue.prototype.$api = api
Vue.prototype.jumuc = jumuc
Vue.prototype.$checkMobile = checkMobile;
Vue.prototype.bus = new Vue();
//路由拦截
router.beforeEach((to, from, next) => {
    if (checkMobile.isMobile) {
        document.addEventListener("jpush.openNotification", function(event) {
            var alertContent = event.alert;
            next({ path: '/jgmessage', query: { 'message': alertContent } });

        }, false);
    }


    //带有iframe的页面不设置app的高度
    if (to.path == '/order/pay' || to.path == '/order/billpay' || to.path == '/game/egg') {
        document.getElementById("app").style.minHeight = 'auto';
        //设置银联支付界面高度
        document.getElementById("payIframe").style.minHeight = window.innerHeight + "px";
    } else {
        var mobileHeight = window.innerHeight + "px";
        document.getElementById("app").style.minHeight = mobileHeight;
    }


    if (!to.meta.isCheck && to.meta.isCheck != null) { //不检验token
        next();
    } else {
        if (localStorage.getItem("token") == "" || localStorage.getItem("token") == null) {
            next({ 'path': '/login' });
        } else {
            api.post(jumuc.user.checkToken, {},
                successRes => {
                    if (successRes.success) {
                        if (checkMobile.isMobile) {
                            api.get(jumuc.getVersion, null,
                                successRes => {
                                    if (checkMobile.isAndroid() && successRes.success) {
                                        try {
                                            var appVersion = plus.storage.getItem('app.version');
                                            if (!appVersion) {
                                                appVersion = "1.0";
                                            }
                                            if (appVersion < Number(successRes.data.andoridVersion)) {
                                                var upr;
                                                plus.nativeUI.confirm('有新版本发布了，是否更新？', function(e) {
                                                    upr = (e.index == 0) ? 'Y' : 'N';
                                                    if (upr == 'Y') {
                                                        var url = api.androidApkUpdateUrl; //下载地址
                                                        var wt = plus.nativeUI.showWaiting('下载更新中，请勿关闭');
                                                        var dtask = plus.downloader.createDownload(url, {}, function(d, status) {
                                                            if (status == 200) {
                                                                var path = d.filename;
                                                                plus.runtime.install(path);
                                                                plus.storage.setItem('app.version', successRes.data.andoridVersion);
                                                            } else { //下载失败
                                                                alert('下载失败:' + status);
                                                            }
                                                        });
                                                        dtask.start();
                                                    } else {}
                                                }, '聚牧城', ['确认', '取消']);
                                            } else {
                                                next();
                                            }

                                        } catch (error) {
                                            next();
                                        }

                                    } else {
                                        next();
                                    }
                                })
                        } else {
                            next();
                        }
                    } else {
                        next({ 'path': '/login' });
                    }
                })
        }
    }
})

router.afterEach((to, from, next) => {
    setTimeout(() => {
        var _hmt = _hmt || [];
        (function() {
            var hm = document.createElement("script");
            hm.src = "https://hm.baidu.com/hm.js?b66ed54644f6b89b0a682771acceb3e3";
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(hm, s);
        })();
    }, 0);
});

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')